import { render } from "./VerifyNotice.vue?vue&type=template&id=7190f374&scoped=true"
import script from "./VerifyNotice.vue?vue&type=script&lang=js"
export * from "./VerifyNotice.vue?vue&type=script&lang=js"

import "./VerifyNotice.vue?vue&type=style&index=0&id=7190f374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7190f374"]])

export default __exports__